var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Message } from 'element-ui';
import axios from 'axios';
import { UrlHelper } from '../../../helper/UrlWrapper';
import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
var CustomerGoodsAliasTable = (function (_super) {
    __extends(CustomerGoodsAliasTable, _super);
    function CustomerGoodsAliasTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [];
        _this.dialogTableVisible = false;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.goodsList = [];
        _this.searchText = '';
        _this.total = 0;
        return _this;
    }
    CustomerGoodsAliasTable.prototype.mounted = function () {
        this.fetchList();
    };
    CustomerGoodsAliasTable.prototype.fetchList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        axios.get('/supplierclientapi/customer/goods_list', {
            params: __assign({ business_id: this.clientId, supplier_to_business_id: this.supplierToBusinessId, key_name: this.searchText }, pager)
        }).then(function (res) {
            if (res.data.success) {
                _this.goodsList = res.data.data || [];
                _this.total = res.data.total || 0;
            }
            else {
                Message.error(res.data.msg || '获取数据失败');
            }
        }).catch(function () {
            Message.error('获取数据失败');
        });
    };
    CustomerGoodsAliasTable.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    CustomerGoodsAliasTable.prototype.pageChange = function (pager) {
        this.fetchList(pager);
    };
    CustomerGoodsAliasTable.prototype.search = function () {
        var pager = (this.$refs.pagination && typeof this.$refs.pagination.getPage === 'function') ? this.$refs.pagination.getPage() : undefined;
        this.fetchList(pager);
    };
    CustomerGoodsAliasTable.prototype.exportGoods = function () {
        var exportUrl = "/supplierclientapi/customer/export_business_goods";
        exportUrl = UrlHelper.addParam(exportUrl, 'business_id', this.clientId);
        exportUrl = UrlHelper.addParam(exportUrl, 'supplier_to_business_id', this.supplierToBusinessId);
        exportUrl = UrlHelper.addParam(exportUrl, 'not_validate_goods', 1);
        exportUrl = UrlHelper.addParam(exportUrl, 'key_name', this.searchText);
        exportUrl = UrlHelper.addParam(exportUrl, 'token', this.user.token);
        if (this.selectRows && this.selectRows.length) {
            exportUrl = UrlHelper.addParam(exportUrl, 'goods_ids', this.selectRows.map(function (item) { return item.supplier_goods_id; }).join(","));
            exportUrl = UrlHelper.addParam(exportUrl, 'goods_format_ids', this.selectRows.map(function (item) { return item.goods_format_id; }).join(","));
        }
        window.open(exportUrl);
    };
    CustomerGoodsAliasTable.prototype.importGoods = function () {
        this.dialogTableVisible = true;
        this.setUploadType("beford");
    };
    CustomerGoodsAliasTable.prototype.befordUpload = function (file) {
        var name = file.name.split("."), fileType = name[name.length - 1];
        if (fileType == "xlsx" || fileType == "xls") {
            if (!this.loadingInstance)
                this.loadingInstance = Loading.service({ fullscreen: true });
            return;
        }
        this.$message.error("文件只能是xlsx或xls");
        return false;
    };
    CustomerGoodsAliasTable.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            var url = "/basicapi/export_error?import_id=" + data.import_id + "&type=" + data.type;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            this.data = (data.goods_list || []).concat(this.data);
            window._czc.push(["_trackEvent", '供货货品', '批量设置客户货品名称', '导入']);
            this.fetchList();
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || "网络异常，请重新导入";
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    CustomerGoodsAliasTable.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || "网络异常，请重新导入";
        this.uploadEnd();
    };
    CustomerGoodsAliasTable.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = "";
            this.setUploadType("beford");
        }
        else {
            this.setUploadType("after");
        }
        this.loadingInstance.close();
    };
    CustomerGoodsAliasTable.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType("importing");
    };
    CustomerGoodsAliasTable.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    CustomerGoodsAliasTable.prototype.onAliasBlur = function (row) {
        var _this = this;
        axios.post('/supplierclientapi/customer/update_goods_alias', {
            supplier_to_business_id: this.supplierToBusinessId,
            supplier_goods_id: row.supplier_goods_id,
            goods_format_id: row.goods_format_id,
            goods_name: row.goods_name
        }).then(function (res) {
            if (!res.data.success) {
                Message.error(res.data.msg || '保存失败');
            }
            else {
                _this.$message.success('保存成功！');
            }
        }).catch(function (err) {
            Message.error(err.message || '保存失败');
        });
    };
    __decorate([
        Prop({ required: true })
    ], CustomerGoodsAliasTable.prototype, "clientId", void 0);
    __decorate([
        Prop({ required: true })
    ], CustomerGoodsAliasTable.prototype, "supplierToBusinessId", void 0);
    CustomerGoodsAliasTable = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], CustomerGoodsAliasTable);
    return CustomerGoodsAliasTable;
}(Vue));
export default CustomerGoodsAliasTable;
